import { useMutation, useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { UPDATE_CUM_COUNTER } from "../../../../queries/mutation/user";
import { GET_CUM_COUNTER } from "../../../../queries/user_queries";
import Loading from "../../../Loading";
import DashCard from "../DashCard";

const CumCounterUpdate = () => {
  const { loading, error, data: cumData, refetch } = useQuery(GET_CUM_COUNTER);

  const [
    updateCumCounter,
    { data: updateData, error: addMutationError, loading: updateLoading },
  ] = useMutation(UPDATE_CUM_COUNTER);

  if (cumData === undefined) {
    return <Loading />;
  }
  const { getCumCounter } = cumData;

  const updateCounter = async (counter: number) => {
    try {
      const { data: responseData } = await updateCumCounter({
        variables: {
          counter,
        },
      });
      if (responseData) {
        await refetch();
        toast.success("Successfully updated cum counter");
      }
    } catch (error: any) {
      toast.error(`Failed to update cum counter: ${error.message}`);
    }
  };

  return (
    <DashCard
      title="Cum counter"
      aside={<span className="text-2xl font-bold text-primary">{getCumCounter}</span>}
    >
      <div className="flex gap-2">
        <button
          className="btn btn-sm btn-success flex-1"
          disabled={updateLoading}
          onClick={() => updateCounter(1)}
        >
          +1
        </button>
        <button
          className="btn btn-sm btn-error btn-outline flex-1"
          disabled={updateLoading}
          onClick={() => updateCounter(-1)}
        >
          −1
        </button>
      </div>
    </DashCard>
  );
};

export default CumCounterUpdate;
